module.exports = __webpack_public_path__ + "img/idCard.0de1f53a.png";